// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useFormContext } from 'react-hook-form';
import type { AccountCurrency } from '@shared/data-access/types/brokerage-types';
import { getCurrencySymbol } from '@shared/portfolio-operations/utils/currency';

export interface RefundFieldsFormValues {
  percentage: number;
  shares: number;
  amount: number;
}

export type FormWithRefundFields = RefundFieldsFormValues & Record<string, unknown>;

export interface UseRefundFieldsProps {
  currency: AccountCurrency | string;
  readOnly?: boolean;
  disabled?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  'data-testid'?: string;
}

export const useRefundFields = (props: UseRefundFieldsProps) => {
  const { currency } = props;

  const { control } = useFormContext<FormWithRefundFields>();

  const currencyPrefix = getCurrencySymbol(currency);

  return {
    control,
    currencyPrefix,
    readOnly: props.readOnly,
    disabled: props.disabled,
    onBlur: props.onBlur,
    'data-testid': props['data-testid'],
  };
};
